<template>
  <div>
    <vs-input class="w-full mb-8" v-model="dataLocal.default" label-placeholder="默认反水比例 (%)" />
    <vs-input class="w-full mb-8" v-model="dataLocal.t1" :label-placeholder="'每月' + dataLocal.t1 + '号第一次发放分红'" />
    <vs-input class="w-full" v-model="dataLocal.t2" :label-placeholder="'每月' + dataLocal.t2 + '号第一次发放分红'" />
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: String,
      default: '{}'
    }
  },
  data() {
    return {
      dataLocal: {}
    }
  },
  methods: {
    getParam() {
      return JSON.stringify(this.dataLocal)
    }
  },
  mounted() {
    this.dataLocal = JSON.parse(this.data)
  }
}
</script>
